/**
 * Display formats for dates and times — one module shared with the Worker
 * (src/shared/format.ts) so a customer and a staff member read the same
 * "Sept 25, 2026" and "2:51 pm" everywhere. Date-times are shown in the
 * viewer's own time zone.
 */
export { formatDate, formatDateTime } from "../../../src/shared/format";

/** "Lucas Bastos" → "Lucas B." — first name plus the last name's initial, for
 *  dense rows where a full name would wrap and two initials say too little.
 *  A single word is returned as it is. */
export function shortName(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0] ?? "";
  const last = parts.length > 1 ? parts[parts.length - 1] : "";
  return last ? `${first} ${last.charAt(0).toUpperCase()}.` : first;
}
